import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionType } from '../../../../enum/question-type.enum';
import { useApp } from '../../../../hook/app.hook';
import { I18nKey } from '../../../../i18n/i18n.key';
import { Section, Question } from '../../../../response/test.response';
import IntigerAnsComponent from '../question-response/intiger-ans.component';
import LongAnsComponent from '../question-response/long-ans.component';
import MultipleChoiceComponent from '../question-response/multiple-choice.component';
import SingleChoiceComponent from '../question-response/sigle-choice.component';
import QuestionComponent from '../question.component';
import './jee-question-holder.css';
import { SecurityManager } from '../../../../security/security-manager';

const JeeQuestionHolderMComponent = () => {
  const { testRes } = useApp();
  const { t } = useTranslation();

  const question = testRes.sectionList
    .filter((section: Section) => section.active)[0]
    .questionList.filter((question: Question) => question.active)[0];

  const getAnswerView = (question: Question): React.ReactNode => {
    const components: Record<QuestionType, React.ReactNode> = {
      [QuestionType.SINGLE_CHOICE]: <SingleChoiceComponent />,
      [QuestionType.MULTIPLE_CHOICE]: <MultipleChoiceComponent />,
      [QuestionType.INT_ANS]: <IntigerAnsComponent />,
      [QuestionType.RANGE_ANS]: <IntigerAnsComponent />,
      [QuestionType.MATRIX_MATCH]: <SingleChoiceComponent />,
      [QuestionType.LONG_ANSWER]: <LongAnsComponent />,
    };

    return components[question.type] || <p>Question Impl not available</p>;
  };

  const isPreview = SecurityManager.getPreview() == true;

  return (
    <div className="font-weight-500">
      {/* Question Section */}
      <div className="w-100 pt-3">
        <div className="d-flex align-items-center border-bottom border-lightgray pb-2">
          <h6 className="font-weight-600 ft-14 mb-0">
            {t(I18nKey.TEST_QUESTION_TEXT)}
            <span className="mx-1">{question.index}</span>
            {isPreview && <span className="mx-1">({question.counter})</span>}
          </h6>
        </div>

        <QuestionComponent question={question} />
      </div>

      {/* Response Section */}
      <div className="w-100 pt-3">
        <div className="d-flex align-items-center border-bottom border-lightgray pb-2">
          <h6 className="font-weight-600 ft-14 mb-0">
            {t(I18nKey.ENTER_YOUR_RESPONSE_TEXT)}
          </h6>
        </div>

        <div className="pt-3 response--mweb-h response--area">
          {getAnswerView(question)}
        </div>
      </div>
    </div>
  );
};

export default memo(JeeQuestionHolderMComponent);
